<template>
    <el-form
        @keyup.enter.native="checkForm"
        :model="form"
        ref="form"
        :rules="validationCompute"
        class="mb-0"
        :disabled="!isAvalaible"
        :inline="inline"
        id="companysearch-form"
        label-position="top"
    >
        <el-alert
            v-if="!isAvalaible || !providerEnabled"
            class="mb-2 is-light"
            :closable="false"
            :title="
                $l10n.__(
                    'Notre partenaire rencontre actuellement un problème technique, la recherche dans l\'annuaire des sociétés est indisponible pour le moment.',
                )
            "
            type="warning"
        ></el-alert>
        <div v-if="!loading">
            <el-form-item :label="$t.__('common.labels.country')" v-if="providers.length > 1">
                <el-select @change="countryCodeSelected" v-model="form.countryCode">
                    <el-option
                        v-for="(provider, index) in providers"
                        :key="index"
                        :value="provider.value"
                        :label="getCountryLabel(provider.value)"
                    />
                </el-select>
            </el-form-item>
            <component
                :is="`${form.countryCode}_form`"
                :providerEnabled="providerEnabled"
                :form="form"
                :useJobCode="useJobCode"
                :inline="inline"
            />
            <!-- </div> -->
            <el-form-item>
                <!-- tricks for vertical align btn with inputs, we add an empty label (seem to be a bug on elemnts when we use inline form with label-position at top) -->
                <span v-if="inline" slot="label">&nbsp;</span>
                <CompassButton
                    :label="$t.__('common.actions.search')"
                    type="primary"
                    :disabled="!providerEnabled"
                    @click="checkForm"
                />
            </el-form-item>
            <preloader v-if="searching" :display="true" size="small" />
        </div>
        <preloader v-else :display="true" size="small" />
    </el-form>
</template>
<script>
import FRForm from './FR_form.vue';
import GBForm from './GB_form.vue';
import CompanySearchMixins from './CompanySearchMixins.js';
import Preloader from 'vcomponents/utilities/Preloader.vue';

export default {
    mixins: [CompanySearchMixins],
    props: {
        countries: {
            type: Array,
            required: false,
            default: () => [],
        },
        searching: {
            type: Boolean,
            required: false,
            default: false,
        },
        useJobCode: {
            type: Boolean,
            required: false,
            default: false,
        },
        inline: {
            type: Boolean,
            required: false,
            default: true,
        },
        context: {
            type: String,
            required: false,
        },
        thirdName: {
            type: String,
            required: false,
        },
        district: {
            type: String,
            required: false,
        },
        validation: {
            type: Object,
            required: false,
            default: function () {
                return {
                    search: [
                        { required: true, message: window.i18n.__('Veuillez saisir un nom') },
                        { min: 2, message: window.i18n.__('2 caractères minimum') },
                    ],
                    district: [{ validator: this.districtValidator }],
                    jobCode: {
                        required: false,
                    },
                };
            },
        },
        listinghash: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            isAvalaible: true,
            providerEnabled: true,
            loading: true,
            providers: [],
            form: {
                countryCode: '',
                search: '',
                district: '',
                jobCode: '',
            },
            validationCompute: this.validation,
        };
    },
    methods: {
        fetchProviders() {
            return new Promise((resolve, reject) => {
                this.$ajax.get(
                    `/companysearch/providers`,
                    {},
                    (result) => {
                        if (result.length) {
                            resolve(result);
                        } else {
                            reject(result);
                        }
                    },
                    (error) => {
                        reject(error);
                    },
                );
            });
        },
        countryCodeSelected(countryCode) {
            this.$emit('countryCodeSelected', { countryCode: countryCode });
            this.cleanForm();
            this.checkEnabled(countryCode);
        },
        cleanForm() {
            this.form.search = '';
            this.form.district = '';
            this.form.jobCode = '';
        },
        checkEnabled(countryCode) {
            let provider = this.providers.find((elt) => elt.value === countryCode);
            if (provider) {
                this.providerEnabled = provider.enabled;
            }
        },
        checkForm() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.$emit('submit', { form: this.form });
                }
            });
        },
        searchCompanies() {
            this.$emit('searchingUpdated', { searching: true });
            this.$ajax.get(
                `/companysearch/search`,
                this.form,
                (response) => {
                    if (Array.isArray(response)) {
                        this.$emit('companies', { companies: response });
                        this.$emit('searchingUpdated', { searching: false });
                    }
                },
                (error) => {
                    if (error.response.data.error) {
                        if (typeof error.response.data.error.message == 'object') {
                            Object.values(error.response.data.error.message).forEach((message) => {
                                Push.error(message);
                            });
                        } else {
                            Push.error(error.response.data.error.message);
                        }
                    }
                    this.$emit('searchingUpdated', { searching: false });
                },
            );
        },
    },

    created() {
        //for listing context, watch filters change in store, reset form data when filters change to empty
        if (this.context === 'listing') {
            this.$store.watch(
                (state) => {
                    return state[this.listinghash].filters;
                },
                (filters) => {
                    if (filters.length === 0) {
                        this.form = {
                            countryCode: this.providers.find((provider) => provider.default).value,
                            search: '',
                            district: '',
                            jobCode: '',
                        };
                    }
                },
                // {
                //     deep: true //add this if u need to watch object properties change etc.
                // }
            );
        }

        new Promise((resolve, reject) => {
            if (this.countries.length > 0) {
                resolve(this.countries);
            } else {
                this.fetchProviders().then(
                    (providers) => {
                        resolve(providers);
                    },
                    () => {
                        reject();
                    },
                );
            }
        }).then(
            (providers) => {
                this.providers = providers;
                this.form.countryCode = this.providers.find((provider) => provider.default).value;
                this.$emit('countryCodeSelected', { countryCode: this.form.countryCode });

                //check if every providers are disabled
                if (!providers.find((elt) => elt.enabled)) {
                    this.isAvalaible = false;
                } else {
                    this.checkEnabled(this.form.countryCode);
                }

                // If the context is update, we lanch the seach if the Name is set
                if (this.context == 'update') {
                    if (this.thirdName !== '') {
                        this.form.search = this.thirdName;
                        this.form.district = this.district ? this.district : '';
                        if (this.isAvalaible && this.providerEnabled) {
                            this.$emit('submit', { form: this.form });
                        }
                    }
                }

                this.loading = false;
            },
            () => {
                this.isAvalaible = false;
                this.loading = false;
            },
        );
    },
    components: {
        FR_form: FRForm,
        GB_form: GBForm,
        Preloader,
    },
};
</script>
